module.exports = __webpack_public_path__ + "img/copy.a2da0c95.svg";